import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import GoogleSearch from "./components/GoogleSearch";
import OverviewPage from "./components/OverviewPage";
import StatsPage from "./components/StatsPage";
import About from "./components/About";
import "./styles/global.css";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<GoogleSearch />} />
        <Route path="/overview" element={<OverviewPage />} />
        <Route path="/stats" element={<StatsPage />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </Router>
  );
};

export default App;
